import GoogleLoginButton from "@/components/GoogleLoginButton";
import AppleLoginButton from "@/components/AppleLoginButton";
import PageTitleScript from "@/components/MetaScript";

const LoginPage = () => {
  return (
    <main className=" flex flex-col min-h-[60vh]">
      <PageTitleScript title="Login" />
      <div className="flex items-center justify-center min-h-[70vh] bg-bg-base px-10">
        <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-md">
          <div className="flex flex-col items-center justify-center">
            <img
              src="/images/logo-square.png"
              alt="RepMates logo"
              width="512"
              height="512"
              className="w-24 h-auto"
            />

            <h1 className="text-2xl font-bold text-tx-dark">RepMates Login</h1>
          </div>

          <div className="space-y-6">
            <div className="flex flex-col items-center gap-2">
              <GoogleLoginButton />
              <AppleLoginButton />

              <div className="mt-6 text-center text-sm text-gray-500">
                <p>
                  By signing in, you agree to our{" "}
                  <a
                    href="https://www.repmates.com/terms"
                    className="font-medium underline  text-tx-link hover:text-tx-link"
                  >
                    Terms of Service
                  </a>{" "}
                  and{" "}
                  <a
                    href="https://www.repmates.com/privacy"
                    className="font-medium underline text-tx-link hover:text-tx-link"
                  >
                    Privacy Policy
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default LoginPage;
